import Vue from 'vue';
import dictJosn from './dict.json';

var echartsData = {
  // 站点名称
  "pointName": {
    "stationName": "收费站名称"
  },
  // 统计时间类型
  "statisticsTimeType": {
    "statisticsTime": "统计时间",
    "statisticsYear": "年",
    "statisticsMonth": "月",
    "statisticsDay": "天",
    "statisticsWeek": "周",
    "statisticsQuarter": "季度",
  },
  //车型
  "vehicleType": {
    "busOne": "一类客车",
    "busTwo": "二类客车",
    "busThree": "三类客车",
    "busFour": "四类客车",
    "truckOne": "一类货车",
    "truckTwo": "二类货车",
    "truckThree": "三类货车",
    "truckFour": "四类货车",
    "truckFive": "五类货车",
    "truckSix": "六类货车",
    "specialOne": "一类专项作业车辆",
    "specialTwo": "二类专项作业车辆",
    "specialThree": "三类专项作业车辆",
    "specialFour": "四类专项作业车辆",
    "specialFive": "五类专项作业车辆",
    "specialSix": "六类专项作业车辆",
  },
  //稽查类型
  "auditType": {
    "suspectFakeIdentify": "车型伪报",
    "suspectFakeTrack": "车牌伪报",
    "suspectFakeDiscount": "货车进入ETC车道",
    "suspectOther": "无车牌",
    "suspectTotal": "疑似逃费数量",
  },
  //通行量
  "CurrentNum": {
    "driveIn": "入口通行量",
    "driveOut": "出口通行量",
  },
  //异常行为
  "AbnormalStatistics": {
    "trackNotEntry": "无入口",
    "trackNotExit": "无出口",
    "notOut": "不入不出",
    "unreachable": "不可达",
    "leakPoint": "漏必经点",
    "trackComplete": "完整轨迹",
    "notPlate": "无车牌",
    "changePlate": "更换车牌",
    "changeIdentifyType": "收费车型改变",
    "lowSpeedDrive": "慢速行驶",
  },
  "abnormalNum": "异常总数",
  "alertType": {
    differentPlate: "车牌不一致",
    differentVehicleType: '车型不一致',
    noPlate: '无车牌',
    truckInEtc: '货车进入ETC车道'
  },
};
Vue.prototype.getQueryCache = function (inputValue) {
  const query = this.$route.params;
  if (typeof inputValue === 'object') {
    Object.keys(inputValue).map(key => {
      if (typeof query[key] !== 'undefined') {
        inputValue[key] = query[key];
      }
    });
  }
};
Vue.prototype.setQueryCache = function (inputValue) {
  const query = {};
  Object.assign(query, inputValue);
  this.$router.push({ query });
};
Vue.prototype.duration = function (val, type) {
  if (type) {
    val = parseInt(val);
    if (val >= 60 * 60) {
      let d = parseInt(val / 60 / 60 / 24);
      let h = val % (60 * 60 * 24);
      let m = h % (60 * 60);
      if (d) {
        return '' + d + '天' + parseInt(h / 60 / 60) + '小时' + parseInt(m / 60) + '分';
      } else {
        return '' + parseInt(h / 60 / 60) + '小时' + parseInt(m / 60) + '分' + m % 60 + '秒';
      }
    } else if (val >= 60 * 60) {
      let h = parseInt(val / 60 / 60);
      let m = val % (60 * 60);
      if (h) {
        return '' + h + '小时' + parseInt(m / 60) + '分' + m % 60 + '秒';
      } else {
        return '' + parseInt(m / 60) + '分' + m % 60 + '秒';
      }
    } else if (val >= 60) {
      return '' + parseInt(val / 60) + '分' + val % 60 + '秒';
    } else {
      return '' + val + '秒';
    }
  } else {
    val = parseInt(val);
    if (val >= 60) {
      return '' + parseInt(val / 60) + '时' + val % 60 + '分';
    } else {
      return '' + val + '分';
    }
  }
};
Vue.prototype.money = function (cent) {
  cent = parseInt(cent);
  return (cent || cent === 0) ? cent / 100 : '--';
};
let wsOnMessage = [];
let wsOnOpen = [];
let wsStatus = [];
window.utils = {
  keepAliveStorage(key, value) {
    let keepAlive = localStorage.keepAlive ? JSON.parse(localStorage.keepAlive) : {};
    keepAlive[key] = value;
    localStorage.keepAlive = JSON.stringify(keepAlive);
  },
  sameObj: function sameObj(o1, o2) {
    if (o1 === o2) return true;
    let keys1 = o1 && Object.keys(o1).sort();
    let keys2 = o2 && Object.keys(o2).sort();
    if (JSON.stringify(keys1) !== JSON.stringify(keys2)) {
      // console.log('不一样的属性: ' + JSON.stringify(keys1), JSON.stringify(keys2))
      return false;
    }
    let isSame = true;
    let len = keys1.length;
    for (let i = 0; i < len; i++) {
      let key = keys1[i];
      let item1 = o1[key];
      let item2 = o2[key];
      if (typeof item1 !== typeof item2) {
        // console.log('不一样的属性: ' + key, item1, item2)
        isSame = false;
        break;
      }
      if (isSame && typeof item1 === 'object') {
        isSame = sameObj(item1, item2);
        if (isSame) {
          continue;
        } else {
          // console.log('不一样的属性: ' + key, item1, item2)
          break;
        }
      }
      if (item1 !== item2) {
        isSame = false;
        // console.log('不一样的属性: ' + key, item1, item2)
        break;
      }
    }
    return isSame;
  },
  // 样式操作
  domInnerHeight(dom) {
    let style = window.getComputedStyle(dom, null);
    let boxSizing = window.utils.domBoxSizing(dom);
    let height = parseInt(style.getPropertyValue('height'));
    if (boxSizing === 'border-box') {
      height -= parseInt(style.getPropertyValue('padding-top')) + parseInt(style.getPropertyValue('padding-bottom'));
      height -= parseInt(style.getPropertyValue('border-top-width')) + parseInt(style.getPropertyValue('border-bottom-width'));
    }
    return height;
  },
  domHeight(dom) {
    let style = window.getComputedStyle(dom, null);
    let boxSizing = window.utils.domBoxSizing(dom);
    let height = parseInt(style.getPropertyValue('height'));
    if (boxSizing === 'content-box') {
      height += parseInt(style.getPropertyValue('padding-top')) + parseInt(style.getPropertyValue('padding-bottom'));
      height += parseInt(style.getPropertyValue('border-top-width')) + parseInt(style.getPropertyValue('border-bottom-width'));
    }
    return height;
  },
  domWidth(dom) {
    let style = window.getComputedStyle(dom, null);
    let boxSizing = window.utils.domBoxSizing(dom);
    let width = parseInt(style.getPropertyValue('width'));
    if (boxSizing === 'content-box') {
      width += parseInt(style.getPropertyValue('padding-left')) + parseInt(style.getPropertyValue('padding-right'));
      width += parseInt(style.getPropertyValue('border-left-width')) + parseInt(style.getPropertyValue('border-right-width'));
    }
    return width;
  },
  domBoxSizing(dom) {
    let target = dom;
    let style = window.getComputedStyle(dom, null);
    let boxSizing = style.getPropertyValue('box-sizing') || 'content-box';
    while (boxSizing === 'inherit') {
      target = target.parentNode;
      let style = window.getComputedStyle(target, null);
      boxSizing = style.getPropertyValue('box-sizing') || 'content-box';
    }
    return boxSizing;
  },
  domStyle(dom, styleName) {
    switch (styleName) {
      case 'width':
        return window.utils.domWidth(dom);
      case 'height':
        return window.utils.domHeight(dom);
      case 'innerHeight':
        return window.utils.domInnerHeight(dom);
      default:
        let style = window.getComputedStyle(dom, null);
        return style.getPropertyValue(styleName);
    }
  },
  break() {
    return new Promise(resolve => {
    });
  },
  nextTick() {
    return new Promise(resolve => {
      Vue.nextTick(resolve);
    });
  },
  // 上下左右按键,嵌入于el-table的控制，默认只控制第一个表格
  WASD() {
    window.onkeydown = (e) => {
      let keynum;
      if (window.event) {
        // IE
        keynum = e.keyCode;
      } else if (e.which) {
        // Netscape/Firefox/Opera
        keynum = e.which;
      }
      if (e.target.tagName === 'INPUT') {
        return;
      }
      if ($('.viewer-in') && $('.viewer-in').length) return;
      switch (keynum) {
        case 38:
          try {
            let focus = $('table').find('.focus')[0] || $('table').find('.current-row')[0];
            if (focus) {
              $(focus).prev().trigger('click');
            } else {
              focus = $('table').find('.el-table__row')[0];
              $(focus).trigger('click');
            }
          } catch (e) {
          }
          break;
        case 40:
          try {
            let focus = $('table').find('.focus')[0] || $('table').find('.current-row')[0];
            if (focus) {
              $(focus).next().trigger('click');
            } else {
              focus = $('table').find('.el-table__row')[0];
              $(focus).trigger('click');
            }
          } catch (e) {
          }
          break;
        case 37:
          try {
            $('.el-pagination').find('.btn-prev').trigger('click');
            $('.table-main-pagination').find('.prev').trigger('click');
          } catch (e) {
          }
          break;
        case 39:
          try {
            $('.el-pagination').find('.btn-next').trigger('click');
            $('.table-main-pagination').find('.next').trigger('click');
          } catch (e) {
          }
          break;
      }
    };
  },
  // 自定义的左右上下键
  setWASD(s, x, z, y) {
    window.onkeydown = (e) => {
      let keynum;
      if (window.event) {
        // IE
        keynum = e.keyCode;
      } else if (e.which) {
        // Netscape/Firefox/Opera
        keynum = e.which;
      }
      switch (keynum) {
        case 38:
          try {
            s();
          } catch (e) {
          }
          break;
        case 40:
          try {
            x();
          } catch (e) {
          }
          break;
        case 37:
          try {
            z();
          } catch (e) {
          }
          break;
        case 39:
          try {
            y();
          } catch (e) {
          }
          break;
      }
    };
  },
  // 上下左右按键关闭
  offWASD() {
    window.onkeydown = (e) => {
    };
  },
  // 字典类型存储转换
  // 使用方法
  // util.dict.get('car_no_colour',{
  //  dictionaries_name:<想搜索的名字>
  // }).dictionaries_value;
  dict: {
    /**
     * 根据(字典类型)、(字典值或字典名)获取(字典名或字典值)
     *
     * @param type {string} 字典类型
     * @param obj {object}  字典名的对象{dictionaries_name:<想搜索的字典名>}，或字典值的对象{dictionaries_value:<想搜索的字典值>}，或者回调函数
     * @param callback {function}  回调函数
     * @returns
     */
    get(type, obj, callback) {
      let data = window.utils.dict.data;
      if (!obj) return data[type] || [];
      if (!data[type]) return [];
      if (obj.dictName !== undefined) {
        return data[type].find(o => o.dictName === obj.dictName) || [];
      }
      if (obj.dictValue !== undefined) {
        return data[type].find(o => o.dictValue === obj.dictValue) || [];
      }
      return [];
    },
    init(data) {
      // 初始化字典
      // data = [licenseColor, identifyType] // 这里是没有加入字典管理的时候写在代码里的字典
      // 否则直接使用参数中的data
      let result = {};
      data.forEach(item => {
        let key = item.dictKey = item.dictionariesKey;
        if (result[key]) {
          result[key] = result[key].concat(item.dictList);
        } else {
          result[key] = item.dictList;
        }
      });
      for (let key in result) {
        let item = result[key];

        // 给 item 排序，未知的都放最后
        item.forEach(i => {
          i.dictName = i.dictionariesName;
          i.dictValue = i.dictionariesValue;
          i.dictKey = i.dictionariesKey;
        });
        let unknown = item.find(o => o.dictName === '未知');
        if (!unknown) continue;
        item.splice(item.indexOf(unknown), 1);
        item.push(unknown);
      }
      // console.log(result);
      window.utils.dict.data = result;
      return result;
    },

    data: []
  },

  echartsDict: {
    /**
     * 根据(字典类型)、(字典值或字典名)获取(字典名或字典值)
     *
     * @param type {string} 字典类型
     * @param obj {string} 要转换的对象
     * @param name:<想搜索的字典名
     * @param callback {function}  回调函数
     * @returns
     */
    get(type, obj, name,) {
      let data = echartsData;
      var result = [];
      if (!obj) return [];
      if (!data[type]) return [];
      if (name !== undefined) {
        for (o in datat[type]) {
          return data[type].find(o === name) || [];
        }
      } else {
        for (var o in data[type]) {
          for (var i in obj) {
            if (o === i)
              result.push(data[type][o]);
          }
        }
        return result;
      }
      return [];
    },
  },

  /**
   * 判断一个 rgb 颜色是否是深色
   * @param color {string} 16进制颜色或rgb颜色
   * @returns {boolean}
   */
  isDeepColor(color) {
    if (/^#/.test(color)) {
      color = color.colorRgb();
    } else if (!/^rgb\(.+\)$/.test(color)) {
      return false;
    }
    let rgbValue = color.replace('rgb(', '').replace(')', '');
    let rgbArr = rgbValue.split(',');
    let grayLevel = rgbArr[0] * 0.299 + rgbArr[1] * 0.587 + rgbArr[2] * 0.114;
    return grayLevel > 192;
  },
  /**
   * 使用方法
   * 1、连接某个 websocket
   */
  websocket: {
    instance: undefined,
    async open(url) {
      // if (window.utils.websocket.instance) return
      window.utils.websocket.instance = new WebSocket(url);
      window.utils.websocket.instance.addEventListener('open', e => {
        window.utils.websocket.instance.send(`{
            "sessionId": "${localStorage.sessionId}",
            "id": "${localStorage.sessionId}",
            "command": "WS.LOGIN",
            "params": {}
          }`);
        wsOnOpen.forEach(item => {
          item.callback(window.utils.websocket.instance);
        });
      });
      window.utils.websocket.instance.addEventListener('message', e => {
        if (!e.data) return;
        let data = JSON.parse(e.data);
        if (!data.data) return;
        wsOnMessage.forEach(item => {
          if (data.data.cmd === item.cmd) {
            item.callback(data.data, window.utils.websocket.instance);
          }
        });
      });
      window.utils.websocket.instance.addEventListener('close', WSClose);

      // 断线重连
      function WSClose(e) {
        console.log(
          `%c websocket %c 断线了`,
          'background:#35495e;padding:1px;border-radius:3px 0 0 3px;color:#FFF',
          'background:#41b883;padding:1px;border-radius:0 3px 3px 0;color:#FFF'
        );
        if (!window.utils.websocket.instance || window.utils.websocket.instance.notReOpen) return;
        window.utils.websocket.instance.close();
        window.utils.websocket.instance = undefined;
        setTimeout(() => {
          console.log('试图重连', url);
          window.utils.websocket.open(url);
        }, 2000);
      }
    },
    onMessage(cmd, callback) {
      let hasSame = wsOnMessage.find(item => item.callback === callback);
      if (hasSame) return; // 不许重复绑定事件监听
      wsOnMessage.push({
        cmd: cmd,
        callback: callback
      });
    },
    offMessage(cmd, callback) {
      if (callback) {
        let that = wsOnMessage.find(item => item.callback === callback && item.cmd === cmd);
        if (!that) return;
        let index = wsOnMessage.indexOf(that);
        wsOnMessage.splice(index, 1);
      } else {
        let those = wsOnMessage.filter(item => item.cmd === cmd);
        those.forEach(item => {
          let index = wsOnMessage.indexOf(item);
          wsOnMessage.splice(index, 1);
        });
      }
    },
    onOpen(cmd, callback) {
      let hasSame = wsOnOpen.find(item => item.callback === callback);
      if (hasSame) return; // 不许重复绑定事件监听
      wsOnOpen.push({
        cmd: cmd,
        callback: callback
      });
    },
    offOpen(cmd, callback) {
      if (callback) {
        let that = wsOnOpen.find(item => item.callback === callback && item.cmd === cmd);
        if (!that) return;
        let index = wsOnOpen.indexOf(that);
        wsOnOpen.splice(index, 1);
      } else {
        let those = wsOnOpen.filter(item => item.cmd === cmd);
        those.forEach(item => {
          let index = wsOnOpen.indexOf(item);
          wsOnOpen.splice(index, 1);
        });
      }
    },
    close() {
      if (!window.utils.websocket.instance) return;
      window.utils.websocket.instance.notReOpen = true;
      window.utils.websocket.instance.close();
    }
  },
  /**
   * 处理数据，保留位数
   * @param array
   */
  toFixed(array) {
    array = array || [];

    function toFixed(obj) {
      if (obj.realCharge) {
        obj.realCharge = ~~(obj.realCharge); // 不保留小数
      }
      if (obj.dueCharge) {
        obj.dueCharge = ~~(obj.dueCharge); // 不保留小数
      }
      if (obj.carWeight) {
        let value = +obj.carWeight;
        let fixed = +value.toFixed(2); // 保留两位小数
        if (value === fixed) {
          obj.carWeight = value;
        } else {
          obj.carWeight = fixed;
        }
      }
      if (obj.axieCount) {
        obj.axieCount = ~~(obj.axieCount); // 不保留小数
      }
      if (obj.mileage) {
        let value = +obj.mileage;
        let fixed = +value.toFixed(3); // 保留3位小数
        if (value === fixed) {
          obj.mileage = value;
        } else {
          obj.mileage = fixed;
        }
      }
      if (obj.spendTime) {
        let value = +obj.spendTime;
        let fixed = +value.toFixed(1); // 保留1位小数
        if (value === fixed) {
          obj.spendTime = value;
        } else {
          obj.spendTime = fixed;
        }
      }
      if (obj.speed) {
        let value = +obj.speed;
        let fixed = +value.toFixed(2); // 保留2位小数
        if (value === fixed) {
          obj.speed = value;
        } else {
          obj.speed = fixed;
        }
      }
      if (obj.dodgingTollSum) {
        obj.dodgingTollSum = ~~(obj.dodgingTollSum); // 不保留小数
      }
    }

    if (array && array.forEach) {
      array.forEach(item => {
        toFixed(item);
      });
    } else {
      toFixed(array);
    }
  },
  await(time) {
    return new Promise(resolve => setTimeout(resolve, time));
  },
  // 数据流转的飞行动画
  async flyAnimate({ menuName, startFunction }) {
    if (!menuName || !startFunction) return;
    startFunction(); // 提示框
    await window.utils.await(1000);
    // TODO 这里通过样式类去获取 menu-box 元素是不严谨的
    let menu = Array.prototype.find.call($('.menu-box:eq(0) .menu-tiem-text'), item => item.innerHTML === menuName);
    if (!menu) return;
    let submenu = $(menu).parents('.el-submenu');
    let targetBox = document.createElement('div');
    let target = $(); // 给个默认值，防爆错
    targetBox.className = 'el-menu asdf';
    targetBox.innerHTML = submenu[0].outerHTML;
    let li = $(targetBox).css({
      position: 'absolute',
      top: submenu.offset().top,
      left: '0',
      width: submenu.width() + 30, // 显得大一些
      border: '2px solid yellow',
      display: 'none'
    }).find('li.el-submenu').addClass('is-active is-opened');
    li.find('.is-active').removeClass('is-active'); // 本来是高亮的菜单要取消高亮
    li.find('ul.el-menu').show()
      .find('.menu-tiem-text').each(function () {
      if (this.innerHTML === menuName) {
        target = $(this);
        target.parent().addClass('is-active'); // 添加新的高亮
      }
    });
    let messageBox = $('.el-message');
    let flyHtml = messageBox[0].outerHTML;
    messageBox.remove();
    $('body').append(flyHtml);
    await window.utils.await(1000);
    document.body.appendChild(targetBox);
    $(targetBox).fadeIn();
    await window.utils.await(500);
    let fly = $('.el-message');
    $(fly).css({
      transition: 'all .5s',
      opacity: 1
    });
    await window.utils.await(400);
    // 开始执行动画
    fly.css({
      transition: 'all 2.5s'
    });
    fly.css({
      transform: `scale(0) translateX(50%)`,
      left: target.width() - 100,
      top: target.offset().top
    });
    await window.utils.await(4500);
    $(fly).remove();
    $(targetBox).fadeOut();
    await window.utils.await(500);
    $(targetBox).remove();
  },
  toTreeJson(option) {
    let result = [];

    function recursion(data, idKey, pidKey, parentNode) {
      _.map(data, (node) => {
        if (!parentNode && !node[pidKey]) {
          node['children'] = [];
          node.class = 1;
          result.push(node);
          recursion(option.data, idKey, pidKey, node);
        } else if (parentNode && node[pidKey] === parentNode[idKey]) {
          if (!parentNode.hasOwnProperty('children')) {
            parentNode['children'] = [];
          }
          node.class = parentNode.class + 1;
          parentNode['children'].push(node);
          recursion(option.data, idKey, pidKey, node);
        }
      });
    }

    recursion(option.data, option.idKey, option.pidKey, null);
    return result;
  },
  setDuration(m) {
    var r = '';
    var h = 60;
    var d = 60 * 24;
    if (m > d) {
      r += parseInt(m / d) + '天';
      m = m % d;
    }
    if (m > h) {
      r += parseInt(m / h) + '小时';
      m = m % h;
    }

    if (m) {
      r += m + '分';
    }
    return r;
  },
  // 计算结束时间
  computedOverTime(type, val) {
    let overtime;
    let now = new Date();
    let year = now.getFullYear();
    let month = now.getMonth();
    let day = now.getDate();
    let h = 23;
    let m = 59;
    let s = 59;
    switch (type) {
      case 'month':
        overtime = new Date(new Date().setMonth(new Date().getMonth() - val));
        break;
      case 'day':
        overtime = new Date(new Date().setDate(new Date().getDate() - val));
        break;
      default:
        overtime = new Date(new Date(year, month, day, h, m, s).getTime());
    }
    return overtime;
  },
  // 深度拷贝
  deepClone: function deepClone(obj) {
    const rootObj = {}; // 记录新的对象
    const cache = [obj]; // 引用对象数组
    const cacheNewValues = [rootObj]; // 记录对应引用的新值

    const assign = (innerObj) => {
      const newObj = innerObj === obj ? rootObj : {};
      Object.keys(innerObj).forEach(key => {
        const value = innerObj[key];
        const index = cache.indexOf(value);
        // 未缓存
        if (index === -1) {
          const type = Object.prototype.toString.call(value);
          if (typeof type === 'object') {
            newObj[key] = assign(value);
            // 记录引用的对象以及对应引用的新值
            cache.push(value);
            cacheNewValues.push(newObj[key]);
          } else {
            newObj[key] = value;
          }
        } else {
          // 已缓存，取对应缓存的新值
          newObj[key] = cacheNewValues[index];
        }
      });

      return newObj;
    };

    return assign(obj);
  },
  // 腾讯地图悬浮层DOMOverlay
  textBox(TMap) {
    function TextBox(options) {
      TMap.DOMOverlay.call(this, options);
    }

    TextBox.prototype = new TMap.DOMOverlay();

    TextBox.prototype.onInit = function (options) {
      this.content = options.content;
      this.content.pointKind = this.content.videoPointKind ? this.content.videoPointKind : this.content.tollPointKind;
      this.content.identifyType = this.content.videoIdentifyType ? this.content.videoIdentifyType : this.content.tollIdentifyType;
      this.content.plateCode = this.content.videoPlateCode ? this.content.videoPlateCode : this.content.tollPlateCode;
      this.content.passTime = this.content.videoPassTime ? this.content.videoPassTime : this.content.tollPassTime;
      this.content.first = options.first;
      this.position = options.position;
      this.eventClick = options.eventClick;
    };
    // 创建信息框
    TextBox.prototype.createDOM = function () {
      var dom = document.createElement('div');
      dom.setAttribute('id', 'TextBox' + this.content.videoPointId);
      let identifyType = window.utils.dict.get('dict_identifyType_option', { dictValue: this.content.identifyType }).dictName;
      let cName = 'map-pop-normal-point';
      if (this.content.first) {
        cName = 'map-pop-normal-point-active';
      }
      if (this.content.pointKind === 1) {
        dom.classList.add('map-pop-normal');
        if (this.content.first) {
          dom.classList.add('active');
        }
        dom.innerHTML = `<div class="map-pop-normal-cont"><p class="behavior">` +
          this.content.driveType + `</p><p class="cont"><span class="car-type">` + identifyType +
          `</span><span class="plate">` + this.content.plateCode + `</span><span>`
          + new Date(this.content.passTime).format('hh:mm') +
          `</span></p></div><div class="map-pop-normal-line"></div><div class="` + cName + `"><div></div></div>`;
        dom.style.cssText = [
          'width: 170px;',
          'height: 80px;',
        ].join(' ');
      } else if (this.content.pointKind === 2) {
        dom.classList.add('map-pop-normal');
        dom.innerHTML = `<div class="map-pop-normal-cont bg-orange"><p class="behavior">` +
          this.content.driveType + `</p></div><div class="map-pop-normal-line bg-orange"></div><div class="bg-orange ` + cName + `"></div></div>`;
        // dom.innerHTML = `<div class="map-pop-normal-ash-point bg-ash"></div>`
        dom.style.cssText = [
          'width: 30px;',
          'height: 80px;',
        ].join(' ');
      } else if (this.content.pointKind === 3) {
        dom.classList.add('map-pop-normal');
        if (this.content.first) {
          dom.classList.add('active');
        }
        dom.innerHTML = `<div class="map-pop-normal-cont bg-red"><p class="behavior">` +
          this.content.driveType + `</p><p class="cont"><span class="car-type">` + identifyType +
          `</span><span class="plate">` + this.content.plateCode + `</span><span>`
          + new Date(this.content.passTime).format('hh:mm') +
          `</span></p></div><div class="map-pop-normal-line bg-red"></div><div class="bg-red ` + cName + `"><div class="bg-red"></div></div>`;
        dom.style.cssText = [
          'width: 170px;',
          'height: 80px;',
        ].join(' ');
      }
      if (this.content.pointKind !== 2) {
        dom.addEventListener('click', this.eventClick, false);
      }
      return dom;
    };

    TextBox.prototype.updateDOM = function () {
      if (!this.map) {
        return;
      }
      // 经纬度坐标转容器像素坐标
      let pixel = this.map.projectToContainer(this.position);
      // 使文本框中心点对齐经纬度坐标点
      let left = pixel.getX() - 15 + 'px';
      let top = pixel.getY() - 70 + 'px';
      this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
      if (this.content.pointKind === 2) {
        let left = pixel.getX() - 15 + 'px';
        let top = pixel.getY() - 70 + 'px';
        this.dom.style.transform = `translate3d(${left}, ${top}, 0px)`;
      }

      this.emit('dom_updated');
    };

    // 移除信息框
    TextBox.prototype.onDestroy = function (videoPointId) {
      var textBox = document.getElementById('TextBox' + videoPointId);
      if (textBox) {
        textBox.parentNode.removeChild(textBox);
      }
    };

    return TextBox;
  },
  // openlayers地图悬浮层
  mapOverlay() {
    function MapOverlay(options) {
      this.onInit(options);
    }

    MapOverlay.prototype.onInit = function (options) {
      this.content = options.content;
      this.content.pointKind = this.content.videoPointKind ? this.content.videoPointKind : this.content.tollPointKind;
      this.content.identifyType = this.content.videoIdentifyType ? this.content.videoIdentifyType : this.content.tollIdentifyType;
      this.content.plateCode = this.content.videoPlateCode ? this.content.videoPlateCode : this.content.tollPlateCode;
      this.content.passTime = this.content.videoPassTime ? this.content.videoPassTime : this.content.tollPassTime;
      this.content.first = options.first;
      this.position = options.position;
      this.eventClick = options.eventClick;
    };
    // 创建信息框
    MapOverlay.prototype.createDOM = function () {
      var dom = document.createElement('div');
      dom.setAttribute('id', 'MapOverlay' + this.content.videoPointId);
      let identifyType = window.utils.dict.get('dict_identifyType_option', { dictValue: this.content.identifyType }).dictName;
      let cName = 'map-pop-normal-point';
      if (this.content.first) {
        cName = 'map-pop-normal-point-active';
      }
      dom.classList.add('map-pop-normal');
      dom.classList.add('map-pop-normal-position');
      if (this.content.pointKind === 1) {
        if (this.content.first) {
          dom.classList.add('active');
        }
        dom.innerHTML = `<div class="map-pop-normal-cont"><p class="behavior">` +
          this.content.driveType + `</p><p class="cont"><span class="car-type">` + identifyType +
          `</span><span class="plate">` + this.content.plateCode + `</span><span>`
          + new Date(this.content.passTime).format('hh:mm') +
          `</span></p></div><div class="map-pop-normal-line"></div><div class="` + cName + `"><div></div></div>`;
        dom.style.cssText = [
          'width: 170px;',
          'height: 80px;',
        ].join(' ');
      } else if (this.content.pointKind === 2) {
        dom.innerHTML = `<div class="map-pop-normal-cont bg-orange"><p class="behavior">` +
          this.content.driveType + `</p></div><div class="map-pop-normal-line bg-orange"></div><div class="bg-orange ` + cName + `"></div></div>`;
        // dom.innerHTML = `<div class="map-pop-normal-ash-point bg-ash"></div>`
        dom.style.cssText = [
          'width: 30px;',
          'height: 80px;',
        ].join(' ');
      } else if (this.content.pointKind === 3) {
        if (this.content.first) {
          dom.classList.add('active');
        }
        dom.innerHTML = `<div class="map-pop-normal-cont bg-red"><p class="behavior">` +
          this.content.driveType + `</p><p class="cont"><span class="car-type">` + identifyType +
          `</span><span class="plate">` + this.content.plateCode + `</span><span>`
          + new Date(this.content.passTime).format('hh:mm') +
          `</span></p></div><div class="map-pop-normal-line bg-red"></div><div class="bg-red ` + cName + `"><div class="bg-red"></div></div>`;
        dom.style.cssText = [
          'width: 170px;',
          'height: 80px;',
        ].join(' ');
      }
      if (this.content.pointKind !== 2) {
        dom.addEventListener('click', this.eventClick, false);
      }
      return dom;
    };

    return MapOverlay;
  },
  // 多线转成腾讯地图折线格式
  multiPolyline(TMap, line, multiLine) {
    var paths = [];
    var a = line.replace('MULTILINESTRING((', "").replace('))', "");
    var LatLng = a.split(',');
    LatLng.forEach(function (p1) {
      var LatLngArr = p1.split(' ');
      multiLine.push([parseFloat(LatLngArr[1]), parseFloat(LatLngArr[0])]);
      paths.push(new TMap.LatLng(parseFloat(LatLngArr[1]), parseFloat(LatLngArr[0])));
    });
    return paths;
  }
  ,
  carType() {
    let options = [];
    let name = window.utils.dict.get('dict_carType_option');
    let identifyType = window.utils.dict.get('dict_identifyType_option');
    name && name.forEach((i) => {
      let children = [];
      identifyType.forEach((item) => {
        if (item.dictName.includes(i.dictName)) {
          children.push({
            value: item.dictValue,
            label: item.dictName
          });
        }
      });
      options.push({
        value: i.dictValue,
        label: i.dictName,
        children: children
      });
    });
    return options;
  }
  ,
  baseInfo: {
    data: null,
    road: {},
    gantry: {},
    list: [],
    init(data) {
      data && data.forEach((i) => {
        i.name = i.roadName;
        i.id = i.roadId;
        i.code = i.roadCode;
        window.utils.baseInfo.road[i.roadId] = i;
        if (i.gantryList && i.gantryList.length) {
          i.gantryList.forEach((item) => {
            item.name = item.gantryName;
            item.id = item.gantryId;
            item.code = item.gantryCode;
            window.utils.baseInfo.gantry[item.gantryCode] = item;
          });
        }
      });
      window.utils.baseInfo.data = data;
      window.utils.baseInfo.getRoadAndGantry();
    },
    getRoadAndGantry() {
      let data = window.utils.baseInfo.data;
      let list = [];
      data && data.forEach((i) => {
        if (!i.parentId) {
          i.children = i.gantryList;
          window.utils.baseInfo.initRoadAndGantry(data, i);
          list.push(i);
        }
      });
      window.utils.baseInfo.list = list;
    },
    initRoadAndGantry(data, currentData) {
      data.forEach((i) => {
        if (i.parentId === currentData.id) {
          currentData.children.push(i);
          i.children = i.gantryList;
          window.utils.baseInfo.initRoadAndGantry(data, i);
        }
      });
    }
  },
  baseMenuName: {
    data: null,
    init(result) {
      let data = {};
      result = _.cloneDeep(result);
      result && result.forEach((item) => {
        if (item.authHas && item.authorityType === 'menu') {
          if (item.children.length > 0) {
            item.children.forEach((i) => {
              if (i.authHas && i.authorityType === 'menu' && i.startPath) {
                data[i.startPath] = i.displayName;
              }
            });
          }
        }
      });
      data['/situation'] = '态势图';
      window.utils.baseMenuName.data = data;
    }
  },
  guangxi_allstation: {
    value: (() => {
      $.ajax({
        url: '../../static/json/guangxi_allstation.json',
        context: document.body,
        async: true,
        success: (res) => {
          window.utils.guangxi_allstation.value = res;
        }
      });
    })()
  },
  // 日期计算
  ///这个方法将取得某年(year)第几周(weeks)的星期几(weekDay)的日期
  getXDate: function (year, weeks, weekDay) {
    // 用指定的年构造一个日期对象，并将日期设置成这个年的1月1日
    // 因为计算机中的月份是从0开始的,所以有如下的构造方法
    let date = new Date(year, "0", "1");
    // 取得这个日期对象 date 的长整形时间 time
    let time = date.getTime();
    // 将这个长整形时间加上第N周的时间偏移
    // 因为第一周就是当前周,所以有:weeks-1,以此类推
    // 7*24*3600000 是一星期的时间毫秒数,(JS中的日期精确到毫秒)
    time += (weeks - 1) * 7 * 24 * 3600000;
    // 为日期对象 date 重新设置成时间 time
    date.setTime(time);
    return this.getNextDate(date, weekDay);
  },
  // 这个方法将取得 某日期(nowDate) 所在周的星期几(weekDay)的日期
  getNextDate: function (nowDate, weekDay) {
    // 0是星期日,1是星期一,...
    weekDay %= 7;
    let day = nowDate.getDay();
    let time = nowDate.getTime();
    let sub = weekDay - day;
    if (sub <= 0) {
      sub += 7;
    }
    time += sub * 24 * 3600000;
    nowDate.setTime(time);
    return nowDate;
  },
  // a标签下载
  aTagGet: function (url) {
    if(window.localStorage.sessionId){
      console.log(window.localStorage.sessionId)
      url = url+'&'+'sessionId='+window.localStorage.sessionId
    }
    console.log(url)
    window.open(url, '_blank')
    // let aTag = document.createElement('a');
    // // aTag.setAttribute("target","_blank");
    // aTag.href = url+'&'+'sessionId='+window.localStorage.sessionId;
    // // Firefox 里需要 append 之后才能触发 click
    // $('body').append(aTag);
    // aTag.click();
    // $(aTag).remove();
  },
  // 翻译角色
  translateRole(roleType) {
    const roleIndex = [1, 2, 3];
    const roleDict = ['超级管理员', '管理员', '普通用户'];
    return roleDict[roleIndex.indexOf(parseInt(roleType))];
  },
};
window.auth = {
  init(menu) {
    window.auth.data = menu;
    Vue.directive('auth', {
      // 当被绑定的元素插入到 DOM 中时……
      inserted: function (el, binding) {
        // 判断是否有权限
        function judgeAuth(arr) {
          arr.forEach(item => {
            if (item.authorityType === 'view' && binding.value === item.authorityName && item.authHas !== true) {
              $(el).hide();
              return;
            }
            if (item.children && item.authorityType !== 'view') {
              judgeAuth.call(this, item.children);
            }
          });
        }

        judgeAuth.call(this, menu);
      }
    });
  },
  getAuth(value) {
    let authHas;

    function judgeAuth(arr) {
      arr.forEach(item => {
        if (item.authorityType === 'view' && value === item.authorityName) {
          authHas = item.authHas;
          return;
        }
        if (item.children && item.authorityType !== 'view') {
          judgeAuth.call(this, item.children);
        }
      });
    }

    judgeAuth.call(this, window.auth.data);
    return authHas;
  },
  getIndex() { // 莫名其妙的方法，原来整个页面由这里控制首页要跳转到那里，但是有问题，不用这个，直接用index.vue跳转
    let startPath;
    function judgeAuth(arr) {
      arr.forEach(item => {
        if (item.authorityType === 'menu' && item.authHas && item.startPath) {
          // console.log('item.startPath',item.startPath)
          startPath = item.startPath;
          return;
        }
        if (item.children && item.authorityType !== 'view') {
          judgeAuth.call(this, item.children);
        }
      });
    }

    judgeAuth.call(this, window.auth.data);
    // console.log('结果:',startPath)
    return startPath;
  },
  data: []
};
window.setAlarmQuery = function (stationCode, plateNumber) {
  // console.log('设置警报参数缓存：', stationCode, plateNumber);
  window.localStorage.alarmStationCode = stationCode;
  window.localStorage.alarmPlateNumber = plateNumber;
};
// 时间格式化
// let time1 = new Date().Format("yyyy-MM-dd")
// let time2 = new Date().Format("yyyy-MM-dd hh:mm:ss")
window.Date.prototype.format = function (fmt) {
  let o = {
    'M+': this.getMonth() + 1,                      // 月份
    'd+': this.getDate(),                           // 日
    'h+': this.getHours(),                          // 小时
    'm+': this.getMinutes(),                        // 分
    's+': this.getSeconds(),                        // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3),    // 季度
    'S': this.getMilliseconds()                     // 毫秒
  };
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  for (let k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)));
    }
  }
  return fmt;
};
